"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToNQError = exports.statusModelToNqError = void 0;
const NQError_1 = require("../NQError");
function statusModelToNqError(statusModel, url) {
    const url_str = url == null ? "" : ` url = ${url}`;
    switch (statusModel.code) {
        case 0:
            return (0, NQError_1.createNqError)("Cl-2", `${statusModel.message}${url_str}`);
        case 428:
            return (0, NQError_1.createNqError)("Ps-1", `${statusModel.message}${url_str}`);
        case 429:
            return (0, NQError_1.createNqError)("Rl-1", `${statusModel.message}${url_str}`);
        default:
            return (0, NQError_1.createNqError)("Ap-Re-5", `${statusModel.message}${url_str}`, statusModel);
    }
}
exports.statusModelToNqError = statusModelToNqError;
function convertToNQError(error) {
    if ((0, NQError_1.isNqError)(error)) {
        return error;
    }
    else {
        console.warn("Unexpected error", error);
        return (0, NQError_1.createNqError)("Cl-0", "Unknown client error", error);
    }
}
exports.convertToNQError = convertToNQError;
//# sourceMappingURL=convertToNQError.js.map